import { SocketioService } from 'src/app/services/socketio.service';
import { ModulomxService } from './../../services/modulomx.service';

import { resolve } from 'url';
import { EntransitoService } from './../../services/entransito.service';

import { BarcoService } from './../../services/barco.service';
import { MovimientospgosService } from './../../services/movimientospgos.service';
import { Licencia } from './../../models/licencia';
import { ListalicenciasService } from 'src/app/services/solicitante/listalicencias.service';
import { Component, ElementRef, OnInit, ViewChild, OnDestroy, Input } from '@angular/core';
import { DateAdapter, MatDialog } from '@angular/material';
import { PrecomprasComponent } from '../precompras/precompras.component';
import { Movimientopago } from 'src/app/models/movimientopgo';
import { SubirarchivoService } from 'src/app/services/subirarchivo/subirarchivo.service';
import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { PrecompraService } from 'src/app/services/precompra.service';
import { PescadorService } from 'src/app/services/solicitante/pescador.service';
import { AsignafolioService } from 'src/app/services/asigafolios/asignafolio.service';
import { EmailService } from 'src/app/services/email/email.service';
import { SolicitanteService } from 'src/app/services/solicitante/solicitante.service';
import Swal from 'sweetalert2';
import { Barcos } from 'src/app/models/barcos';
import { FormGroup, FormBuilder, FormControl, Validators, NgForm, CheckboxRequiredValidator } from '@angular/forms';
import { Solicpescador } from 'src/app/models/solicpescador';
import { Entransito } from 'src/app/models/entransito';
import { promise } from 'protractor';
import { NgxSpinnerService } from 'ngx-spinner';
import { FileService } from 'src/app/services/file.service';

import { saveAs } from 'file-saver';
import { stringify } from '@angular/compiler/src/util';
import { exit } from 'process';
import * as XLSX from 'xlsx';
import { createHost } from '@angular/compiler/src/core';
import { NgIf } from '@angular/common';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import * as moment from 'moment';
import { BotadmonService } from 'src/app/services/botadmon.service';
import { isNull } from 'util';
import { ModalbarcoComponent } from '../modalbarco/modalbarco.component';
import { ReciboreimpresoComponent } from '../reciboreimpreso/reciboreimpreso.component';

import { ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/filter';

// import {Howl, Howler} from 'howler';




@Component({
  selector: 'app-prepago',
  templateUrl: './prepago.component.html',
  styleUrls: ['./prepago.component.css']
})

// const {Howl, Howler} = require('howler');

export class PrepagoComponent implements OnInit {
  // @ViewChild('myForm', {static: false}) myForm: NgForm;
  @ViewChild('subeArchivo2', { static: true }) subeArchivo2: ElementRef;
  @ViewChild('upload', { static: true }) upload: ElementRef;
  @ViewChild('reiniciaarchivo', { static: true }) reiniciaarchivo: ElementRef;
  @ViewChild('btonreset', { static: true }) btonreset: ElementRef;
  @ViewChild('picker', { static: true }) picker: ElementRef;

 // @ViewChild('sendlicenses', { static: true }) sendlicenses: ElementRef;



  order="";


  // @ViewChild ('fechainiciopesca',{static: true}) fechainiciopesca: ElementRef;

  data: [][];
  precioDia = 0;
  forma: FormGroup;
  licencia: Licencia[];
  barco: Barcos[];
  precioSemana = 0;
  precioMes = 0;
  precioAno = 0;
  precioExcursion = 0;
  solicitudhtml = '';
  inventario = 0;
  cveusuario = '';
  nombreArchivoCreado = '';
  diaspesca = 1;
  cantidadpasajeros = 0;
  emailBarco = "**No email registered";
  imagenOculta: boolean; // esta variable mostrara el candado que significa formato validado
  barcoCorrecto: boolean;
  cadenaMensaje = "";

  uploadCaption = '';
  nombrebarco: any;

  nombreEmpresa = '';
  grantotalPagar = 0;

  telefono = '';
  idusuario = '';
  prioridad: number;
  archivoSubir: File;
  emailusuario = '';
  inputconcepto = '';
  botAdminactivado = false;

  modoMtto=false;

  bcantidadpasajerosdiferentes = false;
  bnombrebarcosdiferentes = false;
  bdespliegamensajeadvertencia = false;

  cantidadadquirida = 0;
  listamov: Movimientopago[] = [];
  solicitante: Solicpescador;
  entransito: Entransito;
  cantidaentransito: number;


  nombrearchivoCreado = '';
  nuevonombrearchivo = '';
  extensionArchivo: string;
  numeroConfirmacionStripe = '';
  folioconsecututivoEfectivo = '';
  idsolicitantes = '';
  tipolicencia: string;
  costolicencia: number;
  fechaInicio: Date;
  idnombrebarco = "";

  ano: string;
  mes: string;
  dia: string;
  idregistro: string;
  cantidadsolicitada: number;
  fechapesca = new Date();
  info: any;
  idempresa: string;
  emailempresa: string;
  icono: string;

  fechai: Date;
  fechaf: Date;
  realizarfiltro: boolean;
  identificadorultimacompra: string;
  nombrebarcoseleccion: string;

  mensajesocket: string;
  useradministrador = false;
  deshabilitanoadmin = false;
  unsuscompra: any;
  unsusmovimientos: any;
  uncompralicencia: any;
  unadquierelicencia: any;

  usuarioseleccionadoformato = false;
  MensajemodoMtoo="";

  // colorbarco: string  ="#2f5bb27c";
  // colordia: string="#2f5bb27c";
  // colorpersonas: string="#2f5bb27c";
  // fechavalidas: string="#2f5bb27c";
  // formatocorrecto: string="#2f5bb27c";



  almacenaopcionvalidacionoriginal="";   // esta variable almacenara el valor inicial original de la opcion pedeterminada
  // de la validacion de exceles... servira para cuando el administrador quite o ponga la validacion de manera temporal
  // esta variable almacenara el valor original y posteriormente lo remplazara regresando a la misma opcion predeterminada.
  cambiosenvalidacionexcel=false ;  // esta variable global almacenara su hubo o no cambios de parte del administrador en cuanto
  // a selecciona la validacion en excel.. inicia en false y cambiara a true cuando el administracion hag cambo en la validacion
  opcionelegida_validacionexcel="";  // esta variable tomara le valor del permiso dado al cliente sobre la validacion de excel
  // tiene dos valores : permanente... se refiere al que el cambio es definitivo y temporal que el cambio sera solamente de u solo evento

  activarFormato: string;
  buttonDisabled: boolean = false;




  startDate: string;
  today;
  unsuslistado: any;
  unsussocket: any;




  constructor(
    private dialog: MatDialog,
    private listalicenciasService: ListalicenciasService,
    private movimientopgoService: MovimientospgosService,
    private subirArchivoService: SubirarchivoService,
    private loginUsuario: UsuarioService,
    private precompraService: PrecompraService,
    private pescadorService: PescadorService,
    private asignafolioService: AsignafolioService,
    private emailService: EmailService,
    private solicitanteService: SolicitanteService,
    private barcoService: BarcoService,
    private formBuilder: FormBuilder,
    private entransitoService: EntransitoService,
    private spinner: NgxSpinnerService,
    private fileService: FileService,
    private modulomxService: ModulomxService,
    private socketService: SocketioService,
    private dateAdapter: DateAdapter<Date>,
    private _botadmin: BotadmonService,
    private router: ActivatedRoute



  ) {

    dateAdapter.setLocale('es');

    // este queri viene desde que lllamoron el router
  //   this.router.queryParams
  //   .filter(params => params.order)
  //   .subscribe(params => {
  //    console.log(params); // { order: "popular" }

  //     this.order = params.order;

  //     console.log(this.order); // popular
  //   }
  // );
  }


  // ngOnDestroy() {

  //   this.unsuslistado.unsubscribe();
  //   this.unsussocket.unsubscribe();
  //   this.unsuscompra.unsubscribe();
  //   this.unsusmovimientos.unsubscribe();


  // }


  ngOnInit() {



    
  


    const modomantenimiento = async ()=>{
      let modoto=   localStorage.getItem("servidormtto") ;
      this.MensajemodoMtoo=   localStorage.getItem("servidormttotxt") ;

      this.activarFormato = localStorage.getItem("validarformato");  // esta es la variable que realemnte hace la magia de la validacion
      // el valor es true ... para valiacion completa y false... para sin validacion
      this.almacenaopcionvalidacionoriginal = this.activarFormato; // esta variable guardara el valor de la validacion  y se usara
      // unicamente cuando le administrador quite temporalmente a los clientes la validacion de excel, esta variable restablecera el valor
      // anterior
      this.idempresa = localStorage.getItem("id");

      this.modoMtto = Boolean(JSON.parse(modoto)); 
         
     }

     



    
     // aqui asignaremos otra color a lel logo de sportfishing y parpadeando
     modomantenimiento().then (()=>{
      if (this.activarFormato == "true") {
        this.imagenOculta =false
        this.usuarioseleccionadoformato = true;
      } else {
        this.imagenOculta= false;
        this.usuarioseleccionadoformato = false;
      }

      if (this.MensajemodoMtoo != 'nada') {
       Swal.fire(this.MensajemodoMtoo) 
      }
       
      })


    this.barcoCorrecto = false;
    this.reiniciaarchivo.nativeElement.disabled = true;
    this.btonreset.nativeElement.disabled = true; 




    this.realizarfiltro = false;
    this.icono = 'done_outline';
    this.inventario = 0;
    this.cantidaentransito = 0;
    this.cantidadadquirida = 0;
    this.cveusuario = localStorage.getItem('id');

    // esto controlaba los id de empressa **************************************




    let promise = new Promise((resolve, reject) => {
      setTimeout(() => {

        if (localStorage.getItem('userol') === "ADMIN_SPORTFISHING") {
          this.idempresa = localStorage.getItem('idempresaprepago');
        } else {
          this.idempresa = this.loginUsuario.idempresa;
        }


        if (localStorage.getItem('validarformato') == 'true') {
          this.usuarioseleccionadoformato = true;
          this.imagenOculta =false;
        } else {
          this.usuarioseleccionadoformato = false;
          this.imagenOculta =true;
        }


        this.nombrebarcoseleccion = '';
    this.emailempresa = this.loginUsuario.emailempresa;
    this.nombreEmpresa = this.loginUsuario.nombreempresa;

         resolve (true);
      }, 100);
    });


    
    promise.then((resultado) => {

       //********************************* */


    



    



    
  










    // muesra el pdf en el listado, cuando ya haya respuesta de parte de turipes, esto 
    // esta suscripto y por lo tanto queda en memoria
    this.unsussocket = this.socketService.listen('muestrapdf').subscribe(data => {

      const jsonstring = JSON.stringify(data);
      const obj = JSON.parse(jsonstring);

      // this.lisencolor = obj.color;
      // this.lisennumerofolio = obj.numerofolio;
      // this.colorearenglon(this.lisennumerofolio, this.lisencolor);
     // this.refrescasolicitudes();
     this.ultimaprecompra();
      this.playAudio();

    });





    this.uncompralicencia = this.socketService.listen('compralicencias').subscribe(data => {

      const jsonstring = JSON.stringify(data);
      const obj = JSON.parse(jsonstring);
      console.log(obj.de);
      if (obj.de === this.idempresa) {
        this.ultimaprecompra();
        this.playAudio();
      }

    });


    this.unadquierelicencia = this.socketService.listen('adquierelicencias').subscribe(data => {

      const jsonstring = JSON.stringify(data);
      const obj = JSON.parse(jsonstring);
      console.log(obj.de);
      console.log(this.idempresa);
      if (obj.de === this.idempresa) {
        // this.listadomovimientos();
        this.ultimaprecompra();
        this.playAudio();
      }

    });


   

    this.fechapesca = new Date();
    this.deshabilitanoadmin = !this.loginUsuario.administrador;
    this.useradministrador = this.loginUsuario.administrador;

    this.today = new Date().toISOString().split('T')[0];
    this.uploadCaption = 'Upload Passenger Listing Form';
    this.despliegabarcos(this.idempresa);

    // esta funcion de constate es para localizar y asugnar le precio de licencias a una variable
    // que debe ser la primera en cargarse para continuar ocn todo lo demas
    const getlicenciadia = () => {
      return new Promise((resolve, reject) => {
        this.listalicenciasService.getLicencias().subscribe(licen => {
          this.licencia = licen;
          const preciolicencia = this.licencia[0].preciopublico;
          resolve(preciolicencia);
        });
      });
    };
    // aqui ermina la funcion de constante









    getlicenciadia().then((preciolicencia) => {
      this.precioDia = Number(preciolicencia);

      // aqui se visualizara la ultima compra para efeto de mostrarlo
      this.ultimaprecompra();












    });






    // esta opcion detecta si el botadmin esta activo o desactivado
    this.statusbotAdmin();
    // **************************************************************




    // cambia le color dle boton cuando alguna instancia del mismo objeto presiona kel boton de conectar botsdmin
    // ************************************************************************************************************
    this.socketService.listen("botadminconnectado").subscribe((data) => {
      const jsonstring = JSON.stringify(data);
      const obj = JSON.parse(jsonstring);
      this.botAdminactivado = obj.connectado;
      console.log(this.botAdminactivado);
    });
    // ****************************************************************************
    // *******************************************************************************



    this.socketService.listen("modomantenimiento").subscribe((data) => {
      const jsonstring = JSON.stringify(data);
      const obj = JSON.parse(jsonstring);
  
      // tomamos le valor d el avariable
      // falso quore decir que ya salio dle modo mantenimienot
      // true que enttro a mantenimiento
  
      if (obj.valor =='true' ){
        localStorage.setItem(
          "servidormtto",
          "true"
        );
        
        this.modoMtto = true; 

  
      } else {
  
        localStorage.setItem(
          "servidormtto",
          "false"
        );
       
        this.modoMtto = false; 
      }
  
     
  
  
  
  
      
    });






    this.socketService.listen("validaormatoexcel").subscribe((data) => {
      const jsonstring = JSON.stringify(data);
      const obj = JSON.parse(jsonstring);
      this.cambiosenvalidacionexcel=true;
      this.opcionelegida_validacionexcel = obj.opcion;


      if (obj.valor == true && this.idempresa == obj.idempresa) {
        this.activarFormato = "true";
        localStorage.setItem("validarformato","true");
        this.imagenOculta =false;
        this.usuarioseleccionadoformato = true;

       
      } else if (obj.valor == false && this.idempresa == obj.idempresa) {
        this.activarFormato = "false";
        this.usuarioseleccionadoformato = false;
        localStorage.setItem("validarformato","false");
        this.imagenOculta = true; 
       
      }
    });

    });



   



  }









  statusbotAdmin() {
    this._botadmin.getstatusBotAdmin()
      .subscribe((resp) => {
        const jsonstring = JSON.stringify(resp);
        const obj = JSON.parse(jsonstring);

        if (obj.botadminEncontrado.activado) {
          this.botAdminactivado = true;
        } else {
          this.botAdminactivado = false;
        }



      });
  }


  disponibilidadlicencias(valor: number, ultimoregistro: boolean) {
    if (this.realizarfiltro === false) {
      // this.inventario = valor;
      if (ultimoregistro) {
        // console.log ('aqui entro ultimo');
        if (this.inventario == valor) {
          //       console.log ('igual');
        } else {
          //    console.log ('fiferente');
        }
      }
      return valor;
    } else {
      return 0;
    }

  }


  async tomarpreciolicencia() {
    this.listalicenciasService.getLicencias().subscribe(licen => {
      this.licencia = licen;
      this.precioDia = this.licencia[0].preciopublico;

    });
  }

  abrirmodal() {
    const dialogRef = this.dialog.open(PrecomprasComponent, {
      panelClass: 'mensaje',
      disableClose: true,
      data: {
        identificador: this.precioDia,
        inventario: this.inventario,
        nombrebarco: this.nombrebarco,
        ultimoidprecompra: this.identificadorultimacompra,
      }
    });


    dialogRef.afterClosed().subscribe(
      data => {
        // console.log (data.aceptado);
        // if  (data.aceptado === 'OK') {
        //   const valorinventario: number = this.inventario;
        //   const cantidadcomprada: number = data.cantidad;




        // this.inventario = data.inventariototal;
        this.identificadorultimacompra = data.nuevoidprecompra;
        this.nombrebarcoseleccion = "";
        this.listadomovimientos();







        //  } else {
        //   console.log ('ssin cambos algunos');
        //  }
      }
    );

  }


  ultimaprecompra() {
    this.unsuscompra = this.precompraService.ultimomovimiento(this.idempresa).subscribe(ultimo => {


      if (ultimo.precompra.length === 0) {
        if (this.useradministrador) {

          this.identificadorultimacompra = '0';
          this.abrirmodal();
        } else {
          alert('There are no fishing licenses available, contact your administrator')
        }


      }
      this.identificadorultimacompra = ultimo.precompra[0]._id;
      this.inventario = ultimo.precompra[0].disponibilidad;


      this.listadomovimientos();


    });
  }


  listadomovimientos() {
    this.unsusmovimientos = this.movimientopgoService.listamovimiento(this.idempresa)
      .subscribe(resp => {
        // this.entransito = resp.entransitomovimiento;
        this.cantidaentransito = resp.entransitomovimiento.reduce((
          acc,
          obj,
        ) => acc + (obj.cantidad),
          0);

        this.listamov = resp.movimiento.sort((a, b) => {
          return a.idmovimiento - b.idmovimiento;
        });

        this.limpiarecuadrosolicitudes();
        this.spinner.hide();


      });
  }




  async refrescasolicitudes() {
    console.log("entro a prepago............")
    this.unsuslistado = await this.movimientopgoService.listamovimiento(this.idempresa)
      .subscribe(resp => {
        this.listamov = resp.movimiento.sort((a, b) => {
          return a.idmovimiento - b.idmovimiento;
        });
      });
  }





  limpiarecuadrosolicitudes() {


    this.cantidadadquirida = 0;
    this.nombrebarco = 'Choose...';
    this.uploadCaption = 'Upload Passenger Listing Form';
    this.nuevonombrearchivo = '';


    // this.fechapesca = Date();
    // aqui mandare el la notificacion de socket



  }


  enviarnotificaciondecompra(mensaje: string) {
    // socket envia accion

    this.modulomxService.mensajesolicitudlicencias(this.nombreEmpresa, mensaje);
    this.enviaemail();
  }






  async SeleccionImagen(event) {

    if ((this.nombrebarco !== 'Choose...') && (this.nombrebarco !== '') && (this.cantidadadquirida != 0)) {

      const valorfecha = this.fechaconvertir(this.fechapesca);
      this.nuevonombrearchivo = valorfecha + '_' + '01' + this.cantidadadquirida + '_' + this.nombrebarco + '_' + this.nombreEmpresa;


      const file = event.target.files[0];
      //   console.log(event.target.files[0]);




      this.archivoSubir = file;
      if (this.archivoSubir.size == 0) {
        alert('He detectado que el rchivo que eligio esta vacio, por favor elija el archivo correcto');
        exit;
      } else {
        // this.onFileChange (event)
       //    this.verificaxls(this.nuevonombrearchivo)
      }

      const id = file.name;

      // alert (id);
      this.nombrearchivoCreado = id;
      const vnombreArchivofile = JSON.stringify(this.archivoSubir);


      //   console.log(' nombre archivo  lander', vnombreArchivofile);


      let extensionfile = vnombreArchivofile.indexOf('xlxs');
      //   console.log(extensionfile);

      if (extensionfile === 0) {
        extensionfile = vnombreArchivofile.indexOf('xls');  // en caso de que la extension sea XLS
        if (extensionfile === 0) {
          extensionfile = vnombreArchivofile.indexOf('html');  // en caso de que la extension sea XLS
          if (extensionfile === 0) {

          } else {
            //        alert ('html');
            this.extensionArchivo = 'html';
          }

        } else {
          this.extensionArchivo = 'xls';
        }



      } else {
        this.extensionArchivo = 'xlsx';
      }

      // console.log('archivo a subr', this.archivoSubir);
      this.spinner.show();


      
      await this.subirArchivoService.subirArchivoyrenombra(this.archivoSubir, 'download', id, this.nuevonombrearchivo).then(resp => {
        console.log("**************", resp);
        this.info = JSON.stringify(resp);




        this.info = JSON.parse(this.info);



        this.nuevonombrearchivo = this.nuevonombrearchivo.concat('.', this.extensionArchivo);
        this.uploadCaption = this.nuevonombrearchivo;
        this.spinner.hide();


        //  this.subirArchivoService.comprobarArchivoValido(this.nuevonombrearchivo)
        // .subscribe(resp=>{
        //    console.log ("esta es alguna ", resp);
        //  })

        //this.verificaxls(this.nuevonombrearchivo);


        // usuarioseleccionadoformato fue sustraido de localstore la empresa el cual se toma del nginit 
        console.log("foramto seleccionado", this.usuarioseleccionadoformato);
        if (this.usuarioseleccionadoformato) {
          this.verificaxls(this.nuevonombrearchivo)
        }



      }).catch(resp => {
        console.log('error', resp);
        this.spinner.hide();
      });

      this.upload.nativeElement.disabled = true;

      this.reiniciaarchivo.nativeElement.disabled = false;
      this.btonreset.nativeElement.disabled = false;

    } else {
      this.subeArchivo2.nativeElement.value = "";
      Swal.fire('Oops, Missing request information', 'error')
    }
  }




  Registralicenciassolicitadas() {
    let usuariomx: string
    this.asignafolioService.crearFolios()
      .subscribe(resp => {
        const fechaFolio = resp.fecha;
        const folioconsecutivo = resp.folioconsecutivo;
        if (this.botAdminactivado) {
          usuariomx = "";
        } else {
          usuariomx = this.loginUsuario.usuariomxatencion;
        }

        this.folioconsecututivoEfectivo = 'P' + fechaFolio.concat('-', folioconsecutivo);


        this.solicitante = new Solicpescador(this.nombreEmpresa, this.emailempresa, null, this.cveusuario, null, null, false, 0,
          this.nuevonombrearchivo, this.folioconsecututivoEfectivo, null, null, null, false,
          'precompra', true, this.cantidadadquirida, 0, this.idempresa, this.identificadorultimacompra, null,
          null, null, usuariomx, "", this.emailBarco);

        //   console.log(this.solicitante);

        this.crearSolicitantes(this.solicitante);

        //


      });
  }


  solicitudlicencia() {
    this.realizarfiltro = false;
    if (this.cantidadadquirida > 0) {
      if ((this.nombrebarco !== 'Choose...') && (this.nombrebarco !== '')) {













        if (this.nuevonombrearchivo !== '') {
          this.spinner.show();
          this.Registralicenciassolicitadas();
        } else {
          alert('Seleccione el Archivo XLS');
        }

        

      } else {
        alert('El nombre del barco es necesario');
      }

    } else {
      alert('licenses requested is necesary');
    }

    //  const valorfecha = this.fechaconvertir(this.fechapesca);
    //  this.nuevonombrearchivo = valorfecha + '_' + '01' + this.cantidadadquirida + '_' + this.nombrebarco + '_' + this.nombre;

  }







  crearSolicitantes(solicitante: Solicpescador) {
    //  console.log('solicitante', solicitante);
    this.solicitanteService.crearsolicitanteypescador(solicitante, this.identificadorultimacompra).subscribe(resp => {
      //    console.log ('regresoo info', resp);




      const movimientopago = new Movimientopago(
        this.cveusuario,
        this.idempresa,
        this.identificadorultimacompra,
        resp.idpescador,
        this.nuevonombrearchivo,
        this.nombrebarco,
        0,
        this.cantidadadquirida,
        0,
        Number(this.inventario) - Number(this.cantidadadquirida),
        this.fechapesca,
        '',
        resp.solicitante.numeroperacion
      );




      this.movimientopgoService.crearmovimientospagosyprecompra(movimientopago)
        .subscribe(nuevovalor => {
          //      console.log ('resultado', nuevovalor);
          this.inventario = nuevovalor.inventarioactualizado;
          // = nuevovalor.ldisponiblel;

          const entransito = new Entransito(
            this.idempresa,
            nuevovalor.movimiento.numeroperacion,
            nuevovalor.movimiento.lsolicitado
          );




          this.entransitoService.agregar(entransito)
            .subscribe(valorresultante => {
              this.modulomxService.mensajeadquierelicencias(this.idempresa, 'compralicencias');

            });





          let cantidadpermisos = this.cantidadadquirida;
          this.enviarnotificaciondecompra('Precompra  ' + this.cantidadadquirida + ' Permisos de Día');



        });









    });
  }


  verificainventario() {

    if (Number(this.cantidadadquirida) > Number(this.inventario)) {
      Swal.fire('Oops, You need to purchase more licenses', 'error');
      this.cantidadadquirida = 0;
      this.cantidadpasajeros = 0;
      return;
    }
  }



  reimprimirrecibos(identificador: string, fechadeimpresion: string) {



    const dialogRef = this.dialog.open(ReciboreimpresoComponent, {
      panelClass: 'mensaje',
      disableClose: true,
      data: {
        idmovimiento: identificador,
        fechadeimpresion: fechadeimpresion

      }
    });




  }


  onChange(event) {

    //  console.log ("***********--3",this.nombrebarco);
    this.barcoService.vercorreoBarco(this.idnombrebarco)
      .subscribe(resp => {

        this.nombrebarco = resp.nombrebarco
        if (resp.emailbarco == isNull || resp.emailbarco == undefined) {
          this.emailBarco = "**No Register Email"
        } else {
          this.emailBarco = resp.emailbarco;
        }


      });


  }


  agregarbarcos() {

    const crearbarco = new Barcos(
      this.idempresa,
      this.nombrebarco,
      this.emailBarco
    );


    this.barcoService.agregarbarco(crearbarco)
      .subscribe(resp => {
        this.despliegabarcos(this.idempresa);
      });




  }


  insertabarco() {

    const dialogRefpgobancario = this.dialog.open(ModalbarcoComponent, {
      panelClass: 'mensaje', width: '1000px',
      disableClose: true,
      data: {

        idempresa: this.idempresa,

      }
    });

    dialogRefpgobancario.afterClosed().subscribe(
      data => {

        this.idnombrebarco = "0";
        this.emailBarco="";
        this.despliegabarcos(this.idempresa);
        // this.unsususuarios = this.usuariosptesAceptacion();

        // if (data.aceptado != "False") {
        //   alert("Operation Cancelled2");
        // } else {
        //   alert("Operation Cancelled");
        // }


      }
    );


  }


  despliegabarcos(idempresa: string) {
    this.barcoService.listado(idempresa)
      .subscribe(resp => {
        this.barco = resp;
      });

  }


  // fechaActual() {
  //   const format = 'yyyy-MM-dd';
  //   const locale = 'en-US';

  //   const d = new Date();
  //   const dia = d.getDate();
  //   const mes =  ('0' + (d.getMonth() + 1));
  //   const anio = d.getFullYear();
  //   const fechatotal = dia + '/' + mes + '/' + anio;
  //   const dateObj = new Date(fechatotal);
  //   this.startDate = formatDate(dateObj, format, locale);
  //   console.log ('lafecha actual es' + this.startDate);

  // }

  fechaconvertir(datofecha: Date) {
    const fechaActual = new Date(datofecha);
    let year: string;
    let mes: string;
    let dia: string;


    year = fechaActual.toISOString().slice(2, 4);
    mes = this.conviertemes(fechaActual.getMonth() + 1);
    dia = this.conviertemes(fechaActual.getDate());

    return (year + mes + dia);


  }

  conviertemes(numero: number) {
    let cadena: string;
    cadena = numero.toString();
    const long = cadena.length;
    if (long === 1) {
      return ('0' + cadena);
    } else {
      return cadena;

    }

  }


  iconoseleccion(listadoMov: Movimientopago) {
    if (listadoMov.procesado) {
      this.icono = 'done_outline';
    } else {
      this.icono = 'settings';
    }

    return this.icono;
  }



  playAudio() {
    const audio = new Audio();
    audio.src = '../../../assets/sound/notification_up.mp3';
    audio.load();
    audio.play();
  }




  ejecutarfiltro() {
    this.realizarfiltro = true;
    this.movimientopgoService.getMuestraHistorial(this.nombrebarco, this.fechai, this.fechaf, this.idempresa)
      .subscribe(resp => {
        //   console.log (resp);
        this.listamov = resp;
      });
  }



  download(nombreArchivo: string) {
    //  console.log (nombreArchivo);
    this.fileService.downloadFileExcel(nombreArchivo)
      .subscribe(
        data => saveAs(data, nombreArchivo),
        error => console.error(error)
      );
  }

  // verificaxls(nombrearchivo: string) {
  //   const body = {filename: nombrearchivo};

  //   // return this._http.post('http://localhost:3000/upload/descarga', body, {
  //  // return this._http.post('https://www.app.sportfishingmx.com/upload/descarga', body, {
  //   return this._http.post(environment.rutaverificaxls, body, {
  //       responseType : 'blob',
  //       headers: new HttpHeaders().append('Content-Type', 'application/json')
  //   });
  // }

  verificaxls(nombreArchivo: string) {
    //  console.log (nombreArchivo);
    //var valorfecha  = this.fechapesca;
    var valorfecha = moment((this.fechapesca)).format("YYYY-MM-DD");


    var despliegamensajeadvertencia = false;
    this.movimientopgoService.jsonexcelverificastatus(nombreArchivo, this.cantidadadquirida, this.nombrebarco, valorfecha)
      .subscribe(resp => {
        console.log(resp);

        


        // this.diaspesca = resp.diaspesca;
        //this.nombrebarco = resp.nombrebarco,
        // this.fechapesca = resp.fechaxls1

        this.cadenaMensaje = "";




        if ( resp.formato_oficialerroneo) {
          this.bdespliegamensajeadvertencia = true;
          this.cadenaMensaje = this.cadenaMensaje + ">>Incorrect Excel Request form.  Please use the appropriate form for this type of request."
        }


       
          // if (!resp.deldia) {
          //   this.bcantidadpasajerosdiferentes = true;
          //   this.cadenaMensaje = this.cadenaMensaje + ">>License Category must be designated as ONE DAY. Licenses requested CAN ONLY BE one category at a time"
          // }








        if (this.cantidadadquirida != resp.cuentapasajeros) {
          this.bcantidadpasajerosdiferentes = true;
          this.bdespliegamensajeadvertencia = true;

          this.cadenaMensaje = this.cadenaMensaje + ">> Number of licenses requested and passenger listed do not match, please confirm"
        }

       

        if (this.nombrebarco.toUpperCase().trim() != resp.nombrebarco.toUpperCase().trim()) {
          this.bdespliegamensajeadvertencia = true;
          this.cadenaMensaje = this.cadenaMensaje + "<br/> >> Boat name does not match, please verify Excel file"
        }

        if (resp.bfechasnoconsistentenavegacion) {
          this.bdespliegamensajeadvertencia = true;
          this.cadenaMensaje = this.cadenaMensaje + "<br/> >> Fishing date outside of trip dates, please confirm "
        }


        if (resp.bfechapescaincompleta) {
            this.bdespliegamensajeadvertencia = true;
          this.cadenaMensaje = this.cadenaMensaje + "<br/> >> Excel file's Missing trip departure and return dates, please fill in "
        }

        if (resp.tipolicencia.toUpperCase().indexOf ("DAY") == -1 ) {
          this.bdespliegamensajeadvertencia = true;
          this.cadenaMensaje = this.cadenaMensaje + "<br/> >> Excel file's license category not specified properly, must say 'ONE DAY'"
        }


        if (resp.brectificarfechas) {
          this.bdespliegamensajeadvertencia = true;
          this.cadenaMensaje = this.cadenaMensaje + "<br/> >> Excel file's passenger fishing dates incomplete, missing or already past, please verify.  If all is correct, please verify number of 'Fishing Days' to make sure it is in agreement."
        }

        if (resp.bformatoincompleto) {
          this.bdespliegamensajeadvertencia = true;
          this.cadenaMensaje = this.cadenaMensaje + "<br/> >> Excel file's passenger listing grid has missing or incomplete information, please verify"
        }

        

        if (resp.blineasmediasllenas) {
          this.bdespliegamensajeadvertencia = true;
          this.cadenaMensaje = this.cadenaMensaje + "<br/> >> There is a discrepancy between the number of licenses requested and the passengers listed.  If the information is correct, please delete any extra information on the grid area, such as additional city, state or date listings before saving the excel file  and submitting it again."
        }
        //*[@id="bots"]/thead/tr[2]/td[2]/button/mat-icon


        
        if (resp.bcaracteresprohibidos) {
          this.bdespliegamensajeadvertencia = true;
          this.cadenaMensaje = this.cadenaMensaje + "<br/> >> Special characters, such as asteriks or apostrophes, have been detected in the passengers' names. Please remove any special character, save and reload your passenger list."
        }


        if (resp.bfaltaultimalinea) {
          this.bdespliegamensajeadvertencia = true;
          this.cadenaMensaje = this.cadenaMensaje + "<br/> >> Missing End-of-List Marker, please add one more number to column A"
        }



        let duplicados = [];

        duplicados = resp.duplicados;
        let cantidadduplicado = duplicados.length;

        if (cantidadduplicado > 0) {
          this.bdespliegamensajeadvertencia = true;
          this.cadenaMensaje = this.cadenaMensaje + "<br/> >> Duplicate names found, please correct to make sure they are different: <br/>" + duplicados
        }






        if (this.bdespliegamensajeadvertencia) {
          
          




          Swal.fire({
            title: '<strong> <u>Request Validation</u></strong>',
            icon: 'info',
            html:
              '<hr>' +
              '<h5>' +
              this.cadenaMensaje +

              '</h5>'

          }).then((result) => {
            if (result.isConfirmed) {
              this.btonreset.nativeElement.click();
            }
          })






       //   this.sendlicenses.nativeElement.disabled = true;

        } 
        
        else {
          this.buttonDisabled = false;
    //      this.sendlicenses.nativeElement.disabled = false;
        }











        //         if (resp.barcoCorrecto) {
        //           this.colorbarco = "#00ff00ff"

        //         } else {
        //           this.colorbarco = "rgb(129 164 213)";
        //         }


        //         // aqui coloreara el icono de dia
        //         if (resp.deldia) {
        //           this.colordia = "#00ff00ff"

        //         } else {
        //           this.colordia =  "rgb(129 164 213)";
        //         }


        //          // aqui coloreara elsi la cantidad de personas es correcta
        //          if (resp.cantidadDePasajeros) {
        //           this.colorpersonas = "#00ff00ff"

        //         } else {
        //           this.colorpersonas =  "rgb(129 164 213)";
        //         }


        //  // aqui coloreara elsi la cantidad de personas es correcta
        //  if (resp.fechaseleccionada) {
        //   this.fechavalidas = "#00ff00ff"

        // } else {
        //   this.fechavalidas =  "rgb(129 164 213)";
        // }



        // // aqui coloreara elsi la cantidad de personas es correcta
        // if (resp.formatodecolumnas) {
        //   this.formatocorrecto = "#00ff00ff"

        // } else {
        //   this.formatocorrecto =  "rgb(129 164 213)";
        // }



      })


  }


  onFileChange(evt: any) {
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new console.error('no puedee4 subir multiples archivos');

    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      const wsname: string = wb.SheetNames[0];

      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      console.log(ws);

      this.data = (XLSX.utils.sheet_to_json(ws, { header: 1 }));
      console.log(this.data);

    }

    reader.readAsBinaryString(target.files[0]);

  }

  preprarasubidafile() {
    this.uploadCaption = 'Upload Passenger Listing Form';
    this.subeArchivo2.nativeElement.value = null;
    this.upload.nativeElement.disabled = false;
    this.reiniciaarchivo.nativeElement.disabled = true;
    this.bdespliegamensajeadvertencia = false;
    this.btonreset.nativeElement.disabled = true;
    this.cantidadadquirida = 0;
    //this.nombrebarco = "Choose...";
    this.idnombrebarco = "0";
    this.emailBarco="";

 this.buttonDisabled= true;



  }


  enviaemail() {
    // const nombreArchivocompleto = this.nombreArchivoPDF;
    const subJet = "notificacion :  " + this.loginUsuario.usuariomxatencion + " ha recibido una solicitud de licencias precompradas";

    // const direccionemail = this.txtemail;
    //   const filepdf = nombreArchivocompleto;

    //  this.nombreArchivoPDF = filepdf;
    this.emailService.sendEmailTuripes(subJet)
      .subscribe(
        licen => {
          console.log ("***********por aqui entro");
          this.preprarasubidafile();
          // alert ('listo');
          // this.botonFinalizadeshabilitado = false;
        },

      );
  }


  // checatotalpasajeros() {

  //   this.cantidadadquirida = this.cantidadpasajeros * this.diaspesca;
  //   this.Requested.nativeElement.value = this.cantidadadquirida;
  //   this.verificainventario();
  // }


}







